import React from 'react';
import {connect} from 'react-redux';
import {SessionAwareComponent} from "./SessionAwareComponent";
import Page from "../../../frontend/app/components/Page";
import styles from "../../../frontend/account/containers/css/Login.scss";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import Helmet from "react-helmet";
import {injectIntl, intlShape} from "react-intl";

@injectIntl
export class MaintenanceAwareComponent extends SessionAwareComponent {

    static propTypes = {
        children: PropTypes.node,
        session: ImmutablePropTypes.map.isRequired,
        intl: intlShape.isRequired,
    }

    constructor(props) {
        super(props);
        this.state = { showMaintenanceScreen: false };
    }

    componentDidMount() {
        this.onSessionChange(null, this.props.session);
    }

    onSessionChange(prevSession, session) {
        this.setState({ showMaintenanceScreen: session != null && session.get('maintenance') });
    }

    render() {
        const { showMaintenanceScreen } = this.state;
        const { children } = this.props;
        const { formatMessage } = this.props.intl;

        if (!showMaintenanceScreen) {
            return (<div>{children}</div>);
        }

        return (
            <Page>
                <Helmet title={formatMessage({ id: 'frontend.pagetitle.maintenance' })} />
                <Page.Header />
                <Page.Body>
                    <h1>Takeback befindet sich aktuell im Wartungsmodus.</h1>
                    <p>Wir sind in Kürze wieder zurück. Danke für Ihre Geduld.</p>
                    <hr/>
                    <h2>Takeback is currently under maintenance.</h2>
                    <p>We'll be back shortly. Thank you for your patience.</p>
                </Page.Body>
                <Page.Footer />
            </Page>
        );
    }

}

export default connect(() => ({}))(MaintenanceAwareComponent);
